<template>
  <div>
    <el-dialog :title=" info.id == null ? '创建发票内容' : '修改发票内容'"
               :visible.sync="dialogVisible"
               width="650px">
      <div class="content-wapper"
           v-if="info != null">
        <el-form :model="info"
                 :rules="rules"
                 ref="ruleForm"
                 label-width="150px"
                 style="width:500px;">
          <el-form-item label="发票内容名称"
                        prop="name">
            <el-input placeholder="请输入发票内容名称"
                      v-model="info.name"></el-input>
          </el-form-item>

          <el-form-item label="备注说明"
                        prop="remarks">
            <el-input type="textarea"
                      placeholder="请输入发票内容备注信息说明字"
                      rows="5"
                      resize="none"
                      v-model="info.remarks"></el-input>
          </el-form-item>
        </el-form>
        <div class="button-wapper">
          <el-button size="small"
                     @click="dialogVisible = false">取消</el-button>
          <el-button size="small"
                     type="primary"
                     @click="submit">确认提交</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _invoiceContent from '@/service/invoice-content-service'
export default {
  data () {
    return {
      // 发票内容
      contentName: null,
      invoiceContents: null,
      // 提交信息
      info: {
        id: null,
        name: null,
        remarks: null
      },
      rules: {
        name: [
          { required: true, message: '请输入内容名称', trigger: 'blur' }
        ],

      },
      dialogVisible: false
    }
  },
  methods: {
    show (id) {
      if (id != null) {
        let _loading = this.$loading({ fullscreen: true })
        _invoiceContent.getInvoiceDetail(id, response => {
          _loading.close()
          this.info = response
        }, response => {
          _loading.close()
          this.$notify({
            message: response,
            type: 'warning'
          })
        })
      } else {
        this.info = {
          id: null,
          name: null,
          remarks: null
        }
      }
      this.dialogVisible = true
    },
    // 提交
    submit () {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return false
        }
        // 提交请求
        let _loading = this.$loading({ fullscreen: true })
        _invoiceContent.addOrUpdateInvoice(this.info, () => {
          _loading.close()
          this.$notify({
            message: this.info.id == null ? '添加成功' : '修改成功',
            type: 'success'
          });
          this.dialogVisible = false
          this.$emit('refresh')
        }, response => {
          _loading.close()
          this.$notify({
            message: response,
            type: 'warning'
          })
        })
      })
    }
  }
}
</script>

<style scoped>
.content-wapper {
  margin-bottom: 30px;
}
.button-wapper {
  margin-left: 150px;
}
.button-wapper .el-button {
  width: 150px;
}
.info-wapper {
  font-size: 12px;
}
.info-wapper li {
  margin: 15px 0;
}
.info-wapper div {
  display: inline-block;
  position: relative;
}
.info-wapper span {
  margin-left: 160px;
}
.info-wapper label {
  color: #606266;
  display: inline-block;
  width: 150px;
  text-align: right;
  position: absolute;
  top: -2px;
  padding-right: 12px;
}
.i-content-wapper {
  border: 1px solid #d6dbe5;
  border-bottom: none;
}
.i-content-query {
  padding: 15px;
}
.i-content-query .el-input {
  margin-right: 15px;
}
</style>